import script from "./ValidatePage.vue?vue&type=script&lang=js"
export * from "./ValidatePage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__